const config = {
  Auth: {
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_6j7veB0XM',
    identityPoolId: 'ap-northeast-1:965a72bf-1e12-44e9-814f-1133b2f84015',
    userPoolWebClientId: '5gu07dobm885pl9pfppct4l0jc'
  },
  API: {
    endpoints: [
      {
        name: 'BatchUpdateUserInfoExecution',
        endpoint: 'https://44089o5rkg.execute-api.ap-northeast-1.amazonaws.com/v1',
        region: 'ap-northeast-1'
      },
      {
        name: 'UserDataCsv',
        endpoint: 'https://xn0gr9w063.execute-api.ap-northeast-1.amazonaws.com/v1',
        region: 'ap-northeast-1'
      },
      {
        name: 'UserBasicInfo',
        endpoint: 'https://gmumysoec9.execute-api.ap-northeast-1.amazonaws.com/v1',
        region: 'ap-northeast-1'
      }
    ]
  },
  stepFunction: {
    batchUpdateUserInfoExecution: {
      name: 'BatchUpdateUserInfoExecution',
      arn: 'arn:aws:states:ap-northeast-1:838207131921:stateMachine:smileaya-prod-BatchUpdateUserInfo',
      executionArnPrefix: 'arn:aws:states:ap-northeast-1:838207131921:execution:smileaya-prod-BatchUpdateUserInfo'
    }
  },
  resourceNamePrefix: 'smileaya-prod',
  userInfoTable: 'smileaya-prod-UserInfo',
  userInfoUpdatedDateTable: 'smileaya-prod-UserInfoUpdatedDate',
  userRegistrationTargetUserPoolID: 'ap-northeast-1_FxOjXEusU'
}
export default config
